export default __webpack_public_path__ + "static/media/flyback_controller_ac_ssr_neg.d0284737.svg";